import { css } from 'styled-components';
import * as base from './base';
import * as lightTheme from '../generated/themes/light-theme';

export const cssVariables = css`
  ${base.cssVariables}

  ${lightTheme.cssVariables}
`;

export const theme = {
  ...base.theme,
  ...lightTheme.theme,
};
